import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {z} from "zod"
import {vector2Like} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"
import {imageOpHalOptions} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/image-op-hal-types"

export const segmentType = z.object({
    from: vector2Like,
    to: vector2Like,
    width: z.number(),
})

export const returnType = z.object({
    // referenceSegment: segmentType,
    // searchSegment: segmentType,
    correlationData: z.instanceof(Float32Array),
    peakIndex: vector2Like,
    peakValue: z.number(),
    bestMatchPosition: vector2Like,
})

export const definition = {
    validation: {
        returns: returnType,
        parameters: z.object({
            imageOpHalOptions: imageOpHalOptions,

            sourceImage: anyImageOpResult,
            referenceSegment: segmentType,
            searchSegment: segmentType,
            stride: z.number().int().min(1).optional().default(1),
            penaltyFn: z.function().args(vector2Like).returns(z.number()).optional(),
        }),
    },
}
